import { useBuy } from "./BuyProvider";

export function BuyButton({ location, label = "Buy the Book", className = "", size = "md", testId }) {
  const { openBuy } = useBuy();
  const sizes = {
    sm: "px-6 py-3 text-xs",
    md: "px-8 py-4 text-sm",
    lg: "px-10 py-5 text-sm sm:text-base",
  };
  // The Buy CTA on the Final section is the "main Buy Now" for the funnel.
  // Every other Buy CTA is a secondary buy_open trigger from its own section.
  const ctaId = location === "final" ? "buy_now_main" : `buy_open_${location}`;
  return (
    <button
      onClick={() => openBuy(location)}
      data-testid={testId || `buy-btn-${location}`}
      data-cta={ctaId}
      className={`btn-gold font-label tracking-[0.18em] uppercase rounded-full font-bold ${sizes[size]} ${className}`}
    >
      {label}
    </button>
  );
}

export function GhostButton({ href = "#what", label, className = "", testId }) {
  return (
    <a
      href={href}
      data-testid={testId}
      className={`btn-ghost-gold font-label tracking-[0.18em] uppercase rounded-full font-bold px-8 py-4 text-xs inline-flex items-center justify-center ${className}`}
    >
      {label}
    </a>
  );
}

export function Ornament({ className = "" }) {
  return (
    <div className={`divider-ornament ${className}`}>
      <span className="line" />
      <svg width="46" height="14" viewBox="0 0 46 14" fill="none" className="text-gold">
        <path d="M9 7c0-2.2-1.8-4-4-4S1 4.8 1 7s1.8 4 4 4 4-1.8 4-4zm0 0c0 2.2 1.8 4 4 4s4-1.8 4-4-1.8-4-4-4-4 1.8-4 4z" stroke="currentColor" strokeWidth="1" opacity="0.9"/>
        <circle cx="23" cy="7" r="2" fill="currentColor" />
        <path d="M37 7c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4zm0 0c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4z" stroke="currentColor" strokeWidth="1" opacity="0.9"/>
      </svg>
      <span className="line" />
    </div>
  );
}

export function SectionLabel({ children, num }) {
  return (
    <div className="flex items-center gap-4 mb-6">
      {num && <span className="font-label text-gold text-xs">{num}</span>}
      <span className="h-px w-8 bg-[var(--gold)] opacity-60" />
      <span className="label">{children}</span>
    </div>
  );
}
